var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cp-sub-header',{attrs:{"display-name":_vm.displayName,"business":_vm.isSalon},on:{"gotoTop":_vm.gotoTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }